import axios from 'axios'
import {
  Toast
} from 'vant'
let message = ''
const service = axios.create({
  baseUrl: "",
  timeout: 3 * 1000,
  headers: {
    'Content-Type': 'application/json'
  }
})
//请求拦截
service.interceptors.request.use(config => {
  // config.headers.Authorization = localStorage.getItem('access_token') || '';
  // config.headers.SourceType = JSON.parse(localStorage.getItem('query'))?.sourceType || '';
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})
//响应拦截
service.interceptors.response.use(response => {
  return response
}, error => {
  console.log('error', error)
  if (error.message.indexOf('timeout') != -1) {
    Toast("当前网络不稳定，请退出重试!")
  }


})
export default service
